import { ErrorResponse, Timestamp } from '@lemon/core/model/common'

// export type LemonaidToLemonatorExportType = 'kayttoehtojen hyvaksynnat' | 'sopimuksen hyvaksynta' | 'hetun tallennus' | 'tuntemistietojenStatus annettu'

export enum LemonaidToLemonatorExportType {
  KIELEN_PAIVITYS = 'kielen päivitys',
  KAYTTOEHTOJEN_HYVAKSYNNAT = 'kayttoehtojen hyvaksynnat',
  SOPIMUKSEN_HYVAKSYNTA = 'sopimuksen hyvaksynta',
  HETUN_TALLENNUS = 'hetun tallennus',
  TUNTEMISTIETOJENSTATUS_ANNETTU = 'tuntemistietojenStatus annettu',
  TUO_TILITAPAHTUMAT = 'tuo tilitapahtumat',
  UPDATE_BANK_CONNECTIONS = 'update bank connections',
  // BANK_ACCOUNTS_ACCESSIBLE_PAIVITYS = 'bank accounts accessible päivitys',
  // ALL_ACCESSIBLE_ACCOUNTS_IN_MAKSUTAVAT_PAIVITYS = 'all accessible accounts in maksutavat päivitys',
  STRONG_AUTHENTICATION_FINISHED = 'strong authentication done',
  TERVETULOA_DIALOGI_NAYTETTY = 'tervetuloa dialogi näytetty',
  USER_PEP_TIEDOT_ANNETTU = 'user pep tiedot annettu',
  UPDATE_SALDO_HEITTAA_FLAG = 'update saldo heittää flag',
  TILINPAATOS_USERS_CONVERSION = 'convert board members to tilinpäätös users',
  TILINPAATOS_SIGNED_BY_ALL = 'tilinpäätös signed by all approved board members',
  // YHTIOKOKOUS_SIGNED_BY_ALL = 'yhtiökokous signed by all approved osakkaat',
  YHTIOKOKOUS_SIGNED = 'yhtiökokouksen pöytäkirja signed',
  PHONE_NUMBER_SAVE = 'save user phone number',
  LASKU_MIGRATION = 'lasku migration to lemonator',
  TOSITE_MIGRATION = 'tosite migration to lemonator',
  TOSITTEIDEN_KUUKAUSISUMMAT_UPDATE = 'tositteiden kuukausisummat update',
  REROUTED_EINVOICE_ADDRESS_UPDATED = 'rerouted e-invoice address updated',
  EINVOICE_APPROVED = 'e-invoice approved',
  HOLVI_OAUTH = 'holvi-oauth',
  TAUKO_HALUTAAN_LOPETTAA = 'tauko halutaan lopettaa',
  TILASTO_UPDATE = 'tilasto päivitetään',
  PYYDETTY_MAKSUOMINAISUUDEN_KAYTTOONOTTOA = 'pyydetty maksuominaisuuden käyttöönottoa',
  SELVITYSPYYNTO_VASTATTU = 'selvityspyyntö vastattu',
}

export interface LemonaidToLemonatorExportTyojono {
  aloitettu: Timestamp
  type: LemonaidToLemonatorExportType
  asiakasAvain?: string
  asiakasId?: string
  kayttajaAvain?: string
  selvityspyynnonAvain?: string
}
export interface LemonaidToLemonatorExportReq {
  type: LemonaidToLemonatorExportType
  asiakasAvain: string
  tyojonoAvain: string
  asiakasId?: string
  // secret: string
}
export interface LemonaidToLemonatorExportResp extends ErrorResponse {}

export interface LaskuLemonatoriinData {
  luotu: Timestamp
  asiakasId: string
  asiakasAvain: string
  laskunAvain: string
}
